import { Component, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DrawerButton, DrawerConfig } from '../../../services/drawer-service';

@Component({
  selector: 'app-slide-base-component',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './slide-base-component.html',
  styleUrl: './slide-base-component.scss',
})
export class SlideBaseComponent implements AfterViewInit {
  isResizing = false;
  private originalWidthPx = 0;

  constructor(
    public dialogRef: MatDialogRef<SlideBaseComponent>,
    @Inject(MAT_DIALOG_DATA) public config: DrawerConfig,
    private elementRef: ElementRef,
  ) { }

  ngAfterViewInit(): void {
    if (this.config.onReady) {
      this.config.onReady();
    }
  }

  get visibleButtons(): DrawerButton[] {
    return (this.config.buttons ?? []).slice(0, 2);
  }

  onButtonClick(btn: DrawerButton): void {
    if (!btn.disabled) btn.action();
  }

  private getOverlayPane(): HTMLElement | null {
    let el: HTMLElement | null = this.elementRef.nativeElement;
    while (el) {
      if (el.classList?.contains('cdk-overlay-pane')) return el;
      el = el.parentElement;
    }
    return null;
  }

  onResizeStart(event: MouseEvent): void {
    event.preventDefault();
    const overlayPane = this.getOverlayPane();
    if (!overlayPane) return;

    const startX = event.clientX;
    const startWidth = overlayPane.getBoundingClientRect().width;

    if (this.originalWidthPx === 0) {
      this.originalWidthPx = startWidth;
    }

    this.isResizing = true;
    const minWidth = this.originalWidthPx;

    const onMouseMove = (e: MouseEvent) => {
      const newWidth = Math.max(minWidth, Math.min(window.innerWidth, startWidth + (startX - e.clientX)));
      overlayPane.style.width = newWidth + 'px';
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      this.isResizing = false;
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  }
  onCloseF() {
    this.config.onClose?.();
    this.dialogRef.close();
  }
}